import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
// import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class AuthErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(error) {
    const router = this.injector.get(Router);

    if (error.rejection) {
      if (error.rejection.status === 401 || error.rejection.status === 403) {
        router.navigate(['/login']);
      }

    }
    throw error;
  }

  // TODO: Add better error logging!
  // handleError(error: any) {
  //     const router = this.injector.get(Router);
  //     if (error.rejection && error.rejection.status === 401 || error.rejection.status === 403) {
  //       router.navigate(['/login']);
  //     }
  //     if (error instanceof HttpErrorResponse) {
  //         console.error('There was an HTTP error.', error.message, 'Status code:', (<HttpErrorResponse>error).status);
  //     } else if (error instanceof TypeError) {
  //         console.error('There was a Type error.', error.message);
  //     } else if (error instanceof Error) {
  //         console.error('There was a general error.', error.message);
  //     } else {
  //         console.error('Nobody threw an error but something happened!', error);
  //     }
  // }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/error-handler.ts